import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ReviewFile from './ReviewFile';
import AddNewFile from './AddNewFile';
import clsx from 'clsx';
import { useState } from 'react';
import axios from 'axios';
import { appUrl } from '../../../../../utils/config';
import BackDropLoading from '../models/BackDrop';

const useStyles = makeStyles((theme) => ({
  stepIcon: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E0E0E0',
    color: '#fff',
  },
  active: {
    backgroundColor: '#EC6535', // orange when active
  },
  completed: {
    backgroundColor: '#4CAF50', // green when completed
  },
  number: {
    color: '#fff',
    fontWeight: '550',
  },
  stepConnector: {
    '& $line': {
      borderColor: '#E0E0E0',
    },
  },
  completedStepConnector: {
    '& $line': {
      borderColor: '#4CAF50',
    },
  },
  line: {
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const steps = ['Enter Record Details', 'Review & Submit Record'];
const CustomStepIcon = (props) => {
  const classes = useStyles();
  const { active, completed, icon } = props;

  return (
    <div
      className={clsx(classes.stepIcon, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      <Typography className={classes.number}>{icon}</Typography>
    </div>
  );
};

const AddNewRecord = ({ open, onClose, POLineRecordDetails, GRData }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [poDetails, setPoDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [OtherInfoTempNumber, setOtherInfoTempNumber] = useState(false);
  const [openOtherInfo, setOpenOtherInfo] = useState(false);
  const [isAddRecord, setIsAddRecord] = useState(false);
  const [asnData, setAsnData] = useState({
    asnNumber: '',
    asnDocumentDate: '',
    asnScheduleDeliveryDate: '',
    ewayBillNumber: '',
    ewayBillDate: '',
    boeNumber: '',
    boeDate: '',
    lorryReceiptNumber: '',
    transporterName: '',
    invoiceNumber: '',
    invoiceDate: '',
    challanNumber: '',
    challanDate: '',
    vehicleNumberSupplier: '',
    vehicleNumberCMO: '',
    coaDocumentID: null,
    COAFiles: [],
  });

  const [batchData, setBatchData] = useState({
    // analyticalReportNumber: '',
    batchNumberQA: '',
    numberMRN: '',
    asnUOM: '',
    asnBatchQuantity: '',
    actualQuantityReceived: '',
    materialReceivedDate: '',
    expirationDate: '',
    materialManufactureDate: '',
  });

  // const [coaName, setCoAName] = useState('CertificateOfAnalysis');

  const [POBatchRecordDetails, setPOBatchRecordDetails] = useState('');
  const [otherFiles, setOtherFiles] = useState(
    POBatchRecordDetails?.otherFiles || []
  );

  const [otherInformationRemarks, setOtherInformation] = useState(
    POBatchRecordDetails?.otherInformationRemarks || ''
  );

  const [resError, setResError] = useState(null);
  const [errors, setErrors] = useState({ errorFields: [], errorTitle: '' });

  const classes = useStyles();

  const handleChange = (e, name) => {
    const { value } = e.target;

    // Common reset for error states
    setResError(null);
    setErrors({ errorFields: [], errorTitle: '' });

    // Handle remarks
    if (name === 'otherInformationRemarks') {
      setPOBatchRecordDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleTempNumber = (name) => {
    if (name === 'OtherInfoTempNumber') {
      setOtherInfoTempNumber({
        OtherInfoTempNumber: OtherInfoTempNumber + 1,
      });
    }
  };

  // const handlingFiles = (file, name) => {
  //   if (name === 'otherFiles') {
  //     setPOBatchRecordDetails({
  //       POBatchRecordDetails: {
  //         ...POBatchRecordDetails,
  //         otherFiles: [...POBatchRecordDetails.otherFiles, file],
  //       },
  //     });
  //   }
  //   // this.setState((prevState, props) => ({
  //   //   COAFiles:[ prevState.COAFiles,file]
  //   //   // COAFiles:file
  //   // }));
  // };

  const handlingFiles = (file, name) => {
    if (name === 'otherFiles') {
      setPOBatchRecordDetails((prev) => ({
        ...prev,
        otherFiles: [...(prev.otherFiles || []), file],
      }));
    }
  };

  // const handlingFiles = (newFile, key) => {
  //   setPOBatchRecordDetails((prev) => ({
  //     ...prev,
  //     [key]: [...prev[key], newFile],
  //   }));
  // };

  const handlingDeleteFile = (i, name) => {
    //invoice files deleting in Parent File
    if (name === 'otherFiles') {
      if (
        window.confirm(
          'You are about to delete a file ,would you like to proceed ?'
        )
      ) {
        if (POBatchRecordDetails.otherFiles[i].grFileType === 'buffer') {
          let newdel = POBatchRecordDetails.otherFiles.filter(
            (file) =>
              file.grFileName !== POBatchRecordDetails.otherFiles[i].grFileName
          );
          setPOBatchRecordDetails({
            POBatchRecordDetails: {
              ...POBatchRecordDetails,
              otherFiles: newdel,
              deletePrompt: false,
            },
          });
        }
      }
    }
  };

  const handleNext = ({ sponsorDetails, adminDetails } = {}) => {
    if (handleValidation(asnData, batchData)) {
      setCompleted((prevCompleted) => ({
        ...prevCompleted,
        [activeStep]: true,
      }));
      if (activeStep === 0) {
        // setSponsorDetailsLoading(true);
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const fetchGRNLineDetails = async () => {
      setLoading(true);

      const requestData = {
        supplierPurchaseOrderNumber:
          POLineRecordDetails?.supplierPurchaseOrderNumber,
        materialCode: POLineRecordDetails?.materialCode,
        schrockenSupplierPOBatchID: GRData?.schrockenSupplierPOBatchID,
        collabType: localStorage?.collabType,
        roleName: localStorage?.roleName,
      };

      try {
        const res = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchGRNLineDetails`,
          requestData,
          { cancelToken: source.token }
        );

        setPoDetails(res.data.data.PODetails);

        // const Id =
        //   res?.data?.data?.PODetails?.GRDetails?.asnDetails?.coaDocumentID;
        // if (Id) {
        //   axios
        //     .get(
        //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/getCOADetails/download/${Id}`
        //     )
        //     .then((res) => {
        //       if (res.data.status) {
        //         setCoAName(res.data.fileName);
        //       }
        //     })
        //     .catch((err) => {
        //       console.log(err);
        //     });
        // }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled:', error.message);
        } else {
          console.error('Error fetching PO details:', error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchGRNLineDetails();

    // Cleanup on unmount
    return () => {
      source.cancel('API call canceled due to component unmount.');
    };
  }, []);

  const handleValidation = (ansObj, batchObj) => {
    let valid = true;
    let errorFields = [];
    let errorText = '';
    if (!ansObj?.lorryReceiptNumber) {
      valid = false;
      errorFields.push('lorryReceiptNumber');
      errorText = 'Enter Lorry Receipt (LR) Number';
    }
    if (!ansObj?.transporterName) {
      valid = false;
      errorFields.push('transporterName');
      errorText = 'Enter Transporter Name.';
    }
    if (!ansObj?.invoiceNumber) {
      valid = false;
      errorFields.push('invoiceNumber');
      errorText = 'Enter invoice number.';
    }
    if (!ansObj?.invoiceDate) {
      valid = false;
      errorFields.push('invoiceDate');
      errorText = 'Enter invoice date.';
    }
    // if (!batchObj?.analyticalReportNumber) {
    //   valid = false;
    //   errorFields.push('analyticalReportNumber');
    //   errorText = 'Enter analytical report number.';
    // }
    if (!batchObj?.batchNumberQA) {
      valid = false;
      errorFields.push('batchNumberQA');
      errorText = 'Enter Supplier Batch Number.';
    }
    if (!batchObj?.numberMRN) {
      valid = false;
      errorFields.push('numberMRN');
      errorText = 'Enter MRN number.';
    }
    if (!parseFloat(batchObj?.actualQuantityReceived)) {
      valid = false;
      errorFields.push('actualQuantityReceived');
      errorText = 'Enter actual quantity received.';
    }
    if (!batchObj?.materialReceivedDate) {
      valid = false;
      errorFields.push('materialReceivedDate');
      errorText = 'Enter material received date.';
    }
    if (!batchObj?.expirationDate) {
      valid = false;
      errorFields.push('expirationDate');
      errorText = 'Enter expiration date.';
    }
    if (!batchObj?.materialManufactureDate) {
      valid = false;
      errorFields.push('materialManufactureDate');
      errorText = 'Enter manufacture date.';
    }

    if (batchObj?.materialManufactureDate && batchObj?.expirationDate) {
      const date1 = new Date(batchObj?.materialManufactureDate);
      const date2 = new Date(batchObj?.expirationDate);

      if (date1 > date2) {
        valid = false;
        errorFields.push('expirationDate');
        errorText = 'Please enter valid expiration Date.';
      }
    }

    if (errorFields.length > 1) {
      errorText = 'Some required fields are missing.';
    }

    setErrors({
      errorFields: errorFields,
      errorTitle: errorText,
    });
    return valid;
  };

  useEffect(() => {
    setErrors({
      errorFields: [],
      errorTitle: '',
    });
  }, [asnData, batchData]);

  return (
    <>
      <BackDropLoading />
      <Stepper
        alternativeLabel
        nonLinear
        activeStep={activeStep}
        connector={
          <StepConnector
            classes={{
              active: classes.stepConnector,
              completed: classes.completedStepConnector,
              line: classes.line,
            }}
          />
        }
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={(props) => (
                <CustomStepIcon
                  {...props}
                  completed={completed[index]}
                  icon={index + 1}
                />
              )}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      {/* {activeStep === 0 && <QAInformation />} */}
      {activeStep === 0 && (
        <AddNewFile
          onSave={handleNext}
          poDetails={poDetails}
          POLineRecordDetails={POLineRecordDetails}
          GRData={GRData}
          asnData={asnData}
          setAsnData={setAsnData}
          batchData={batchData}
          setBatchData={setBatchData}
          handleChange={handleChange}
          openOtherInfo={openOtherInfo}
          resError={resError}
          OtherInfoTempNumber={OtherInfoTempNumber}
          handleTempNumber={handleTempNumber}
          handlingFiles={handlingFiles}
          handlingDeleteFile={handlingDeleteFile}
          POBatchRecordDetails={POBatchRecordDetails}
          setPOBatchRecordDetails={setPOBatchRecordDetails}
          otherFiles={otherFiles}
          setOtherFiles={setOtherFiles}
          otherInformationRemarks={otherInformationRemarks}
          setOtherInformation={setOtherInformation}
          // coaName={coaName}
          errors={errors}
        />
      )}
      {activeStep === 1 && (
        <ReviewFile
          onClose={onClose}
          poDetails={poDetails}
          handleChange={handleChange}
          POLineRecordDetails={POLineRecordDetails}
          GRData={GRData}
          asnData={asnData}
          setAsnData={setAsnData}
          batchData={batchData}
          setBatchData={setBatchData}
          openOtherInfo={openOtherInfo}
          resError={resError}
          OtherInfoTempNumber={OtherInfoTempNumber}
          handleTempNumber={handleTempNumber}
          handlingFiles={handlingFiles}
          handlingDeleteFile={handlingDeleteFile}
          POBatchRecordDetails={POBatchRecordDetails}
          setPOBatchRecordDetails={setPOBatchRecordDetails}
          otherFiles={otherFiles}
          setOtherFiles={setOtherFiles}
          otherInformationRemarks={otherInformationRemarks}
          setOtherInformation={setOtherInformation}
          // coaName={coaName}
          handleValidation={handleValidation}
          errors={errors}
        />
      )}
    </>
  );
};

export default AddNewRecord;
